<template>
  <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M44.0019 84.5917C66.4201 84.5917 84.5936 66.4181 84.5936 43.9999C84.5936 21.5817 66.4201 3.4082 44.0019 3.4082C21.5837 3.4082 3.41016 21.5817 3.41016 43.9999C3.41016 66.4181 21.5837 84.5917 44.0019 84.5917Z"
      fill="#00CA42"
    />
    <path
      d="M44 88C19.7404 88 0 68.2631 0 44C0 19.7404 19.7404 0 44 0C68.2631 0 88 19.7404 88 44C88 68.2631 68.2631 88 44 88ZM44 6.81639C23.4962 6.81639 6.81639 23.4962 6.81639 44C6.81639 64.5038 23.4962 81.1836 44 81.1836C64.5038 81.1836 81.1836 64.5004 81.1836 44C81.1836 23.4962 64.5038 6.81639 44 6.81639Z"
      fill="#00CA42"
    />
    <path
      d="M38.6835 60.1894C37.7701 60.1894 36.8975 59.8247 36.2533 59.1703L23.6771 46.3895C22.3581 45.0467 22.3751 42.8927 23.718 41.5703C25.0608 40.2548 27.2182 40.2684 28.5372 41.6112L38.5846 51.8222L59.3714 28.9293C60.6426 27.5354 62.7967 27.4365 64.1837 28.6976C65.5776 29.9621 65.6799 32.116 64.4154 33.5133L41.2056 59.0748C40.5751 59.77 39.6889 60.1722 38.7517 60.1926C38.7278 60.1894 38.7074 60.1894 38.6835 60.1894Z"
      fill="white"
    />
  </svg>
</template>
